<form [formGroup]="printForm" soho-busyindicator class="pdf-action-form" [ngClass]="{'form-layout-compact': useCompactFormLayout}">
  <div *ngIf="useTabs; then TAB_CONTENT; else NON_TAB_CONTENT"></div>

  <ng-template #TAB_CONTENT>
    <div *ngIf="true then CONTEXT_FORM"></div>
    <div soho-tabs>
      <div soho-tab-list-container>
        <ul soho-tab-list>
          <li soho-tab [hidden]="false">
            <a soho-tab-title tabId="tabs-pdf-display" data-automation-id="lm-print-to-pdf-display-tab">{{'PDFDisplayTab' | translate}}</a>
          </li>
          <li soho-tab [hidden]="pdfType === 'regularFormPdf'">
            <a soho-tab-title tabId="tabs-pdf-content" data-automation-id="lm-print-to-pdf-content-tab">{{'PDFContentTab' | translate}}</a>
          </li>
          <li soho-tab [hidden]="!isUseAllActorGroups">
            <a soho-tab-title tabId="tabs-pdf-sharing" data-automation-id="lm-print-to-pdf-sharing-tab">{{'PDFSharingTab' | translate}}</a>
        </li>
        </ul>
      </div>
    </div>
    <div soho-tab-panel tabId="tabs-pdf-display">
      <div *ngIf="true then DISPLAY_OPTIONS"></div>
    </div>
    <div soho-tab-panel tabId="tabs-pdf-content">
      <div *ngIf="true then CONTENT_OPTIONS"></div>
    </div>
    <div soho-tab-panel tabId="tabs-pdf-sharing">
      <div *ngIf="true then SHARING_OPTIONS"></div>
    </div>
  </ng-template>  <!--TAB_CONTENT-->
  <ng-template #NON_TAB_CONTENT>
    <div *ngIf="true then CONTEXT_FORM"></div>
    <div *ngIf="true then DISPLAY_OPTIONS"></div>
  </ng-template>   <!--NON_TAB_CONTENT-->

  <ng-template #CONTEXT_FORM>
    <div>
      <div  class="pdf-tab-row">
        <div class="pdf-criteria field">
          <label for="name">{{'Name' | translate}}</label>
          <input formControlName="name" type="text" id="name" data-automation-id="lm-print-to-pdf-name" maxlength="40" soho-trackdirty/>
        </div>
        <div class="pdf-criteria field only-alert">
          <label for="recordLimitAlert"></label>
          <span id="recordLimitAlert" soho-alert data-automation-id="lm-print-to-pdf-record-limit-alert"></span>
        </div>
      </div>
    </div>
  </ng-template> <!--CONTEXT_FORM-->
  <ng-template #DISPLAY_OPTIONS>
    <div class="pdf-tab-content">
      <div class="pdf-tab-row">
        <div class="field field-radio pdf-criteria">
          <input formControlName="orientation" type="radio" class="radio field" id="landscape" data-automation-id="lm-print-to-pdf-landscape-orientation" [value]="'landscape'" soho-trackdirty />
          <label for="landscape" class="radio-label">{{'PDFOrientationLandscape' | translate}}</label>
          <input formControlName="orientation" type="radio" class="radio field" id="portrait" data-automation-id="lm-print-to-pdf-portrait-orientation" [value]="'portrait'" soho-trackdirty />
          <label for="portrait" class="radio-label">{{'PDFOrientationPortrait' | translate}}</label>
        </div>
      </div>
      <div  class="pdf-tab-row">
        <div class="pdf-criteria field">
          <label soho-label for="fontOffsetOption">{{'PDFFontSizeOffset' | translate}}</label>
          <select formControlName="fontOffsetOption" soho-dropdown id="fontOffsetOption" data-automation-id="lm-print-to-pdf-font-offset-option" noSearch soho-trackdirty class="dropdown-md">
            <option [value]="'default'">{{'PDFFontSizeOffsetDefault' | translate}}</option>
            <option [value]="'small'">{{'PDFFontSizeOffsetSmall' | translate}}</option>
            <option [value]="'smaller'">{{'PDFFontSizeOffsetSmaller' | translate}}</option>
            <option [value]="'smallest'">{{'PDFFontSizeOffsetSmallest' | translate}}</option>
            <option [value]="'custom'">{{'PDFFontSizeOffsetCustom' | translate}}</option>
          </select>
        </div>
        <div *ngIf="showFontOffset" class="field pdf-criteria lm-no-label" >
          <label soho-label for="fontOffset"></label>
          <input formControlName="fontOffset" soho-spinbox id="fontOffset" data-automation-id="lm-print-to-pdf-font-offset" data-options="{ min:-5, max:20 }" soho-trackdirty class="input-xs"/>
        </div>
      </div>
    </div>
  </ng-template> <!--DISPLAY_OPTIONS-->
  <ng-template #SHARING_OPTIONS>
    <div class="pdf-tab-content">
      <div  class="pdf-tab-row">
        <div class="field pdf-criteria">
          <lm-lookup-basic #reportDistributionGroup data-automation-id="lm-print-to-pdf-distribution-group"
           [fieldLabel]="reportDistGroupLabel"
           [sourceField]="sourceFieldName"
           (onLookupValueChangedEvent) = "reportDistributionGroupChanged($event)">
          </lm-lookup-basic>
        </div>
        <div class="field pdf-criteria" [hidden]="!showDynamicActors">
          <label soho-label for="dynamicActors"
             [required]="atLeastOneDynamicActor">{{dynamicActorsLabel}}</label>
          <lm-list-dropdown #dynamicActorsComponent id="dynamicActors" data-automation-id="lm-print-to-pdf-dynamic-actors"
            [options]="dynamicActorOptions" soho-alert></lm-list-dropdown>
        </div>
      </div>
    </div>
  </ng-template> <!--SHARING_OPTIONS-->
  <ng-template #CONTENT_OPTIONS>
    <div class="pdf-tab-content">
      <div class="pdf-tab-row" *ngIf="printInfo.includeRecordLimit">
        <div class="pdf-criteria field">
          <label soho-label for="recordLimitOption">{{'PDFCSVRecordLimit' | translate}}</label>
          <select formControlName="recordLimitOption" soho-dropdown id="recordLimitOption" data-automation-id="lm-print-to-pdf-record-limit-option" noSearch soho-trackdirty class="dropdown-md">
            <option [value]="'default'">{{'PDFDefaultRecordsOption' | translate}}</option>
            <option [value]="'all'">{{'PDFAllRecordsOption' | translate}}</option>
            <option [value]="'large'">{{'PDFLargeRecordsOption' | translate}}</option>
            <option [value]="'small'">{{'PDFSmallRecordsOption' | translate}}</option>
            <option [value]="'custom'">{{'PDFCustomRecordsOption' | translate}}</option>
          </select>
        </div>
        <div class="pdf-criteria field" *ngIf="showMaxRows">
          <label soho-label for="maxRows"></label>
          <input formControlName="maxRows" #maxRows soho-spinbox data-options="{ min:0, step:100 }" soho-trackdirty id="maxRows" data-automation-id="lm-print-to-pdf-record-max-rows" class="input-sm"/>
        </div>
      </div>
      <div  class="pdf-tab-row" *ngIf="includePrintOption">
        <div class="pdf-criteria field">
          <label soho-label for="printOption">{{'PDFPrintOptions' | translate}}</label>
          <select formControlName="printOption" soho-dropdown id="printOption" data-automation-id="lm-print-to-pdf-print-option" noSearch soho-trackdirty class="dropdown-md">
            <option *ngFor="let option of printOptions" [value]="option.value">{{option.label}}</option>
          </select>
        </div>
        <div class="pdf-criteria field" *ngIf="isTreeList && showMaxLevels">
          <label soho-label for="maxLevels"></label>
          <input formControlName="maxLevels" #maxLevels soho-spinbox min="1" max="99" soho-trackdirty id="maxLevels" data-automation-id="lm-print-to-pdf-max-levels" class="input-xs"/>
        </div>
      </div>
      <div class="pdf-criteria field top-margin" *ngIf="includeSearchForm">
        <input formControlName="searchForm" soho-checkbox type="checkbox" id="searchForm" data-automation-id="lm-print-to-pdf-include-search-form"soho-trackdirty />
        <label for="searchForm" class="checkbox-label">{{'PDFIncludeSearchForm' | translate}}</label>
      </div>
    </div>
  </ng-template> <!--CONTENT_OPTIONS-->
</form>
<div #modalPlaceholder></div>
